module.exports = __webpack_public_path__ + "static/media/HO13.fb157576.png";